module.exports = __webpack_public_path__ + "static/media/user.88e97874.svg";